import React from "react";
import { useSelector } from "react-redux";
import { NGIcon } from "asset/icons";
import { Dialog, DialogContent } from "../ui/Dialog";
import { Button } from "../ui/Button";

export default function OutstandingMaintenanceFeeModal({
  isOpen = false,
  onClose,
  onFundWallet,
  feesToDisplay
}) {
  const { users: user } = useSelector((s) => s || {});
  const firstName = user?.firstName || user?.first_name || user?.name?.split(" ")[0] || "there";

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose?.(); }}>
      <DialogContent onInteractOutside={(e) => e.preventDefault()} className="max-w-[480px] p-6 md:px-8 md:py-4 rounded-[12px] w-11/12 sm:w-full border-none overflow-hidden sm:max-w-[480px] bg-white text-left">
        <div className="space-y-4">
          {/* Title */}
          <p className="text-2xl font-semibold leading-8 text-[#020618] text-left">
            We couldn’t charge your maintenance fee(s)
          </p>

          {/* Description */}
          <div className="text-[#45556C] space-y-4 text-sm font-[350] leading-6">
            <p className="text-sm font-[350] leading-6" style={{ lineHeight: "24px !important" }}>
              Hi {firstName},
            </p>

            <p className="text-sm font-[350] leading-6" style={{ lineHeight: "24px !important" }}>
              We couldn’t charge the monthly maintenance fees for the wallets below.
            </p>

            <p className="text-sm font-[350] leading-6" style={{ lineHeight: "24px !important" }}>
              Please fund the affected wallet to cover the outstanding fees and avoid disruption to payment services.
            </p>
          </div>

          {/* Outstanding Fees Section */}
          <div className="space-y-2">
            <p className="text-sm font-[450] leading-5 text-[#020618]">
              Outstanding fees
            </p>

            <div className="bg-[#FBFAFF] rounded-lg p-3.5 space-y-3 border border-[#EBE4FF]">
              {feesToDisplay.map((item, idx) => {
                const ItemIcon = item.Icon || NGIcon;
                return (
                  <div key={idx} className="flex items-center justify-between text-xs md:text-[13px]">
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-5 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0">
                        <ItemIcon className="w-full h-full object-cover" />
                      </div>
                      <span className="font-[500] text-sm leading-6  text-[#101828]">{item.currency}</span>
                    </div>
                    <span className="text-[#475467] font-[450] text-sm leading-[140%]">
                      {item.amount}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Support Note */}
          <p className="text-[#45556C] text-sm font-[350] leading-6 md:text-sm" style={{ lineHeight: "22px !important" }}>
            If you no longer need any of these wallets, contact support or your account manager to close them.
          </p>

          {/* Footer Action Buttons */}
          <div className="flex items-center justify-end gap-3 pt-2">
            <Button
              type="button"
              variant="ghost"
              onClick={onClose}
              className="text-[#344054] hover:text-[#101828] text-xs md:text-base font-medium px-4 py-2"
            >
              I’ll do this later
            </Button>
            <Button
              type="button"
              onClick={onFundWallet || onClose}
              className="!bg-[#6F00FF] hover:!bg-[#5e00db] text-white text-xs md:text-base font-medium px-6 py-2.5 rounded-lg transition-all shadow-sm"
            >
              Fund wallet
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
